import { Checkbox, Input, Typography } from "antd";
import { GhtkSettingModel } from "states/transportation/transportation.models";

export interface IGhtkApiSettingFormProps {
  model: GhtkSettingModel;
  onChange: (newModel: GhtkSettingModel) => void;
}

export function GhtkApiSettingForm(props: IGhtkApiSettingFormProps) {
  const { model, onChange } = props;
  return model ? (
    <>
      <Input.Group className="mb-4">
        <Typography.Text>Token: </Typography.Text>
        <Input
          value={model.token}
          onChange={(e) => {
            onChange({ ...model, token: e.target.value });
          }}
        />
      </Input.Group>
      <Input.Group className="mb-4">
        <Checkbox
          checked={model.isSandbox}
          onChange={(e) => {
            onChange({ ...model, isSandbox: e.target.checked });
          }}
        >
          Môi trường test
        </Checkbox>
      </Input.Group>
      <Input.Group className="mb-4">
        <Checkbox
          checked={model.isActive}
          onChange={(e) => {
            onChange({ ...model, isActive: e.target.checked });
          }}
        >
          Kích hoạt
        </Checkbox>
      </Input.Group>
    </>
  ) : null;
}
